/**
 * Parse the HTML status chip the series listing API still returns
 * (e.g. `<span class='label label-success'>Active</span>`) into a
 * plain label + the ACE background color used as the Quimby Status dot.
 *
 * Display-only: this does not change how status is edited.
 */
const ACE_LABEL_BACKGROUND = {
    'label-success': '#82af6f',
    'label-important': '#d15b47',
    'label-danger': '#d15b47',
    'label-warning': '#f89406',
    'label-info': '#3a87ad',
    'label-primary': '#2283c5',
    'label-inverse': '#333333',
    'label-grey': '#a0a0a0',
    'label-pink': '#d6487e',
    'label-purple': '#9585bf',
    'label-yellow': '#fee188',
    'label-light': '#e7e7e7',
    'label-default': '#abbac3'
};
/** ACE `.label` default background when no modifier class is present. */
export const SERIES_STATUS_DEFAULT_COLOR = '#abbac3';
function firstInlineBackground(el) {
    if (!(el instanceof HTMLElement))
        return '';
    return (el.style.backgroundColor || el.style.background || '').trim();
}
function colorFromLabelClass(el) {
    if (!el)
        return null;
    const match = Object.keys(ACE_LABEL_BACKGROUND).find((className) => el.classList.contains(className));
    return match ? ACE_LABEL_BACKGROUND[match] : null;
}
export function parseSeriesStatusHtml(html) {
    var _a, _b, _c;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.body.firstElementChild;
    const label = ((_b = (_a = el === null || el === void 0 ? void 0 : el.textContent) !== null && _a !== void 0 ? _a : doc.body.textContent) !== null && _b !== void 0 ? _b : '').replace(/\s+/g, ' ').trim();
    if (!label) {
        return { label: '-', color: SERIES_STATUS_DEFAULT_COLOR };
    }
    const inline = firstInlineBackground(el);
    if (inline) {
        return { label, color: inline };
    }
    return { label, color: (_c = colorFromLabelClass(el)) !== null && _c !== void 0 ? _c : SERIES_STATUS_DEFAULT_COLOR };
}
